/**
 * @generated SignedSource<<50772a8e063a2607b35e981da619c8ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCustomerInput = {
  clientMutationId?: string | null | undefined;
  email?: string | null | undefined;
  name: string;
  notes?: string | null | undefined;
  phone?: string | null | undefined;
};
export type OpsCustomersPageCreateMutation$variables = {
  input: CreateCustomerInput;
};
export type OpsCustomersPageCreateMutation$data = {
  readonly createCustomer: {
    readonly customer: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsCustomersPageCreateMutation = {
  response: OpsCustomersPageCreateMutation$data;
  variables: OpsCustomersPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCustomerPayload",
    "kind": "LinkedField",
    "name": "createCustomer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsCustomersPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsCustomersPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c99d4a4a6533c8824b1fea9be71ce505",
    "id": null,
    "metadata": {},
    "name": "OpsCustomersPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsCustomersPageCreateMutation(\n  $input: CreateCustomerInput!\n) {\n  createCustomer(input: $input) {\n    customer {\n      id\n      name\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c3a2eafdc6ed550ad4bf66eaae2aadf";

export default node;
